// Copyright 2024 - MinIO, Inc. All rights reserved.

import { createAsyncThunk } from "@reduxjs/toolkit";
import { ingressRpc } from "../../api";
import { setErrorSnackBarMessage } from "../systemSlice";
import { errorToHandler } from "../../api/error";

export const listIngressAsync = createAsyncThunk(
  "ingress/listIngressAsync",
  async (
    {
      siteId,
      namespace,
    }: {
      siteId: string;
      namespace: string;
    },
    { getState, rejectWithValue, dispatch },
  ) => {
    return ingressRpc.api
      .listIngresses(siteId, namespace)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.error(err);
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(err);
      });
  },
);
